const TOPIC_TAGS = [
  { id: 1, label: '韩漫推荐', hot: true, count: '1.2w' },
  { id: 2, label: '日漫连载', hot: true, count: '9.8k' },
  { id: 3, label: '国漫崛起', hot: true, count: '8.5k' },
  { id: 4, label: '免费全集', hot: false, count: '7.2k' },
  { id: 5, label: '下拉式漫画', hot: true, count: '6.4k' },
  { id: 6, label: '恋爱漫画', hot: false, count: '5.9k' },
  { id: 7, label: '热血漫画', hot: true, count: '5.3k' },
  { id: 8, label: '悬疑条漫', hot: false, count: '4.7k' },
  { id: 9, label: '追更必备', hot: true, count: '4.1k' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            漫迷们正在热烈讨论的热门话题标签，看看大家都在关注什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPIC_TAGS.map((tag) => (
            <a
              key={tag.id}
              href="#topics"
              className="group relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200/70 bg-background-50 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              {tag.hot && (
                <span className="absolute -top-1.5 -right-1 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-background-50"></span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                #{tag.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full">
                {tag.count}
              </span>
            </a>
          ))}
        </div>

        <p className="text-center mt-8 text-xs text-foreground-400">
          数据实时更新 · 反映当前漫画社区热门讨论趋势
        </p>
      </div>
    </section>
  );
}